<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M12 7C9.5 4 5 4 3 8C1 12 5 15.5 12 20C19 15.5 23 12 21 8C19 4 14.5 4 12 7Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconHeart',
  props: { size: { type: [String, Number], default: 24 } },
};
</script>
